import { logger } from './logger';
import { ConsoleTransport, DataDogTransport } from './transports';
import { ENV } from '@user-portal/helpers';

interface SetupLoggerOptions {
    env: ENV;
    dataDog?: {
        clientToken: string;
        serviceName: string;
        version?: string;
        sessionSampleRate: number;
    };
}

export function setupLogger({ env, dataDog }: SetupLoggerOptions) {
    if (env === ENV.develop) {
        console.log('Logger initialized in development mode with ConsoleTransport');
        logger.addTransport(new ConsoleTransport());
    } else {
        if (!dataDog) {
            throw new Error('DataDog config required for production');
        }

        logger.addTransport(new DataDogTransport({ ...dataDog, env }));
    }
}
